export default "__VITE_ASSET__Cd5xvM1U__"